import React from 'react';
import { Doughnut } from 'react-chartjs-2';

function SemiDoughnutChart(props) {
    let labels = []
    let values = []
    if (props.data) {
        props.data.length && props.data.forEach(ele => {
            if (ele.tmode !== "All") {
                labels.push(ele.tmode);
                values.push(ele.total)
            }
        })
    }
    console.log(labels)

    const data = {
        labels: labels,
        datasets: [
            {
                data: values,
                backgroundColor: [`rgba(10, 45, 68)`, `rgba(0, 185, 181)`, "#58585A", '#742f68', '#6190CB', '#c95f95', '#32BA8B'],
            },
        ],
    };
    const options = {
        legend: {
            // display: false,
            position: "bottom",
            labels: {
                fontColor: "#333",
                usePointStyle: false,
            },
        },
        rotation: 1 * Math.PI,
        // responsive: true,
        // maintainAspectRatio: true,
        circumference: 1 * Math.PI,
        cutoutPercentage: 70,
        plugins: {
            datalabels: {
                display: true,
                color: "white",
            },
        },
    };

    return (
        <Doughnut data={data} options={options} />
    )
}

export default React.memo(SemiDoughnutChart)
